import React, { Component } from "react";
import "./App.css";
import { contentData } from "./data";
import Sentence from "./Sentence";
import Word from "./Word";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

class Content extends Component {
    state = {
        sentences: [],
        words: [],
   };
    constructor(props) {
        super(props);
        this.state.sentences = contentData.sentence; //.filter(sentence => sentence.seance == 1);
        //const result = words.filter(word => word.length > 6);
    }
    render() {
        return (
            <>
                <Tabs>
                    <TabList>
                        <Tab>Sentence</Tab>
                        <Tab>Words</Tab>
                    </TabList>

                    <TabPanel>
                        {this.state.sentences.map((data, key) => {
                            return (
                                <div key={key}>

                                    <Sentence sentence={data} />
                                </div>
                            );
                        })}
                    </TabPanel>
                    <TabPanel>
                        {Object.keys(contentData.words).map((data, key) => {
                            return (
                                <div key={key}>
                                    <Word word={contentData.words[data]} />
                                </div>
                            );
                        })}
                    </TabPanel>
                </Tabs>
            </>
        );
    }
}

export default Content;